import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { updateRouteParams } from '../../redux/actions/navigation';

class RouteDataProvider extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    params: PropTypes.object.isRequired,
    zipCode: PropTypes.string,
    creditRating: PropTypes.string,
    updateParams: PropTypes.func.isRequired,
  };
  static defaultProps = {
    zipCode: undefined,
    creditRating: 0
  };
  constructor(props) {
    super(props);
    this.handleParams = this.handleParams.bind(this);
  }
  componentWillMount() {
    this.handleParams(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.params !== nextProps.params
      || this.props.zipCode !== nextProps.zipCode
      || this.props.creditRating !== nextProps.creditRating
    ) {
      this.handleParams(nextProps);
    }
  }
  shouldComponentUpdate(nextProps) {
    return this.props.children !== nextProps.children;
  }
  handleParams(props) {
    const { updateParams } = this.props;
    const mergedProps = {
      ...props.params,
      zipcode: props.zipCode,
      creditRating: props.creditRating,
    };
    updateParams(mergedProps);
  }
  render() {
    const { children } = this.props;
    if (React.isValidElement(children)) {
      return children;
    }
    return (
      <div>
        {children}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  zipCode: state.dma.zipCode,
  creditRating: state.userAmounts.creditRating,
});

const mapDispatchToProps = dispatch => ({
  updateParams: bindActionCreators(updateRouteParams, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteDataProvider);



/** WEBPACK FOOTER **
 ** ./src/components/RouteDataProvider/index.js
 **/